import React from 'react'
import { Link } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { theme } from '@acorns/web-components'
import { useAnalyticsClient } from '@acorns/web-utils'
import styled from 'styled-components'

import { GROW_BUTTON } from 'utils/testing/testIDs'

import { ACTIONS, baseAnalyticsOptions } from '../../analytics'
import { usePublishingContext } from '../../PublishingContext'
import { RECAP_XS_BREAKPOINT } from '../../styles'

const RECAP_MEDIUM_BREAKPOINT = 900

const Wrapper = styled.div`
  position: absolute;
  right: -100px;
  top: -60px;

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    right: -50px;
  }

  @media screen and (max-width: ${RECAP_MEDIUM_BREAKPOINT - 1}px) {
    right: -122px;
  }

  @media screen and (max-width: 650px) {
    right: -15px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    right: 15px;
    top: -10px;
  }
`

const StyledLink = styled(Link)`
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
  display: flex;
  height: 44px;
  justify-content: center;
  width: 44px;

  path {
    fill: ${theme.colors.white};
  }
`

const ArticleButton = ({
  beneficiaryId,
  section,
}: {
  beneficiaryId: string
  section: string
}): React.ReactElement => {
  const analytics = useAnalyticsClient()
  const { isCustodian } = usePublishingContext()

  const handleClick = () => {
    analytics.track(ACTIONS.BUTTON_TAPPED, {
      ...baseAnalyticsOptions,
      action: 'Tapped',
      beneficiaryId,
      context: section,
      event_description: 'Early Quarterly Recaps Grow CTA Tapped',
      object: 'Button',
      object_name: 'earlyQuarterlyRecapsGrowCTA',
    })
  }

  const pathPrefix = isCustodian
    ? `/early/quarterly-recap/${beneficiaryId}`
    : '/recap'

  return (
    <Wrapper data-testid={GROW_BUTTON} onClick={handleClick}>
      <StyledLink
        aria-label={`Go to ${section} article`}
        to={`${pathPrefix}/article/${section}`}
      >
        <AcornsIcon icon={AcornsIcon.Icon.ProductGrowFv} width={24} />
      </StyledLink>
    </Wrapper>
  )
}

export { ArticleButton }
